/**
 * Quick Add to Cart - Shelf/Collection
 * Adiciona produtos ao carrinho direto da vitrine com modal de variantes
 */

(function() {
  'use strict';

  let currentProduct = null;

  /**
   * Abre modal de seleção de variantes
   */
  window.quickAddProduct = function(productId, variantId) {
    event.preventDefault();
    
    // Busca dados do produto
    fetch(`/products/${productId}.js`)
      .then(response => response.json())
      .then(product => {
        currentProduct = product;
        
        // Se tem apenas 1 variante ou produto simples, adiciona direto
        if (product.variants.length === 1) {
          addToCart(product.variants[0].id);
          return;
        }
        
        // Se tem variantes, abre modal
        openVariantModal(product, variantId);
      })
      .catch(error => {
        console.error('Erro ao buscar produto:', error);
        if (window.theme && window.theme.showToast) {
          window.theme.showToast('Erro ao carregar produto', 'error', 3000);
        }
      });
  };

  /**
   * Abre modal de seleção de variantes
   */
  function openVariantModal(product, selectedVariantId) {
    const modal = createModalHTML(product, selectedVariantId);
    document.body.insertAdjacentHTML('beforeend', modal);
    
    // Timeout para animação
    setTimeout(() => {
      document.querySelector('.quick-add-modal').classList.add('active');
    }, 10);
    
    // Event listeners
    setupModalEvents();
  }

  /**
   * Cria HTML do modal
   */
  function createModalHTML(product, selectedVariantId) {
    const selectedVariant = product.variants.find(v => v.id === selectedVariantId) || product.variants[0];
    
    // Gera HTML para todas as opções (exceto 'Title')
    let optionsHTML = '';
    product.options.forEach((option, optionIndex) => {
      if (option.name === 'Title') return;
      
      const optionPosition = optionIndex + 1; // option1, option2, option3
      const selectedValue = selectedVariant[`option${optionPosition}`];
      
      optionsHTML += `
        <div class="quick-add-modal__option" data-option-index="${optionPosition}">
          <label>${option.name}</label>
          <div class="quick-add-modal__values">
            ${option.values.map(value => {
              // Verifica se há variantes disponíveis com esse valor
              const availableVariants = product.variants.filter(v => 
                v[`option${optionPosition}`] === value && v.available
              );
              
              const isSelected = value === selectedValue;
              const isAvailable = availableVariants.length > 0;
              
              return `
                <button 
                  class="quick-add-modal__value ${isSelected ? 'active' : ''} ${!isAvailable ? 'unavailable' : ''}"
                  data-option-index="${optionPosition}"
                  data-value="${value}"
                  ${!isAvailable ? 'disabled' : ''}
                >
                  ${value}
                </button>
              `;
            }).join('')}
          </div>
        </div>
      `;
    });
    
    return `
      <div class="quick-add-modal">
        <div class="quick-add-modal__overlay"></div>
        <div class="quick-add-modal__content">
          <button class="quick-add-modal__close">×</button>
          
          <div class="quick-add-modal__image">
            <img src="${selectedVariant.featured_image?.src || product.featured_image}" alt="${product.title}">
          </div>
          
          <div class="quick-add-modal__info">
            <h3 class="quick-add-modal__title">${product.title}</h3>
            
            ${optionsHTML}
            
            <button class="quick-add-modal__add" 
                    data-variant-id="${selectedVariant.id}"
                    ${!selectedVariant.available ? 'disabled' : ''}>
              ${selectedVariant.available ? 'Comprar' : 'Indisponível'}
            </button>
          </div>
        </div>
      </div>
    `;
  }

  /**
   * Configura eventos do modal
   */
  function setupModalEvents() {
    const modal = document.querySelector('.quick-add-modal');
    const overlay = modal.querySelector('.quick-add-modal__overlay');
    const closeBtn = modal.querySelector('.quick-add-modal__close');
    const addBtn = modal.querySelector('.quick-add-modal__add');
    const valueButtons = modal.querySelectorAll('.quick-add-modal__value');
    
    // Fechar
    const closeModal = () => {
      modal.classList.remove('active');
      setTimeout(() => modal.remove(), 300);
    };
    
    overlay.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);
    
    // Selecionar opção
    valueButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        if (this.disabled) return;
        
        const optionIndex = this.dataset.optionIndex;
        const value = this.dataset.value;
        
        // Remove active dos botões da mesma opção
        const sameOptionButtons = modal.querySelectorAll(`.quick-add-modal__value[data-option-index="${optionIndex}"]`);
        sameOptionButtons.forEach(b => b.classList.remove('active'));
        
        // Adiciona active no clicado
        this.classList.add('active');
        
        // Busca variante correspondente às opções selecionadas
        updateSelectedVariant();
      });
    });
    
    // Adicionar ao carrinho
    addBtn.addEventListener('click', function() {
      if (this.disabled) return;
      const variantId = this.dataset.variantId;
      addToCart(variantId);
      closeModal();
    });
  }

  /**
   * Atualiza variante selecionada baseado nas opções escolhidas
   */
  function updateSelectedVariant() {
    const modal = document.querySelector('.quick-add-modal');
    const addBtn = modal.querySelector('.quick-add-modal__add');
    
    // Pega valores selecionados de cada opção
    const selectedOptions = {};
    for (let i = 1; i <= 3; i++) {
      const activeBtn = modal.querySelector(`.quick-add-modal__value[data-option-index="${i}"].active`);
      if (activeBtn) {
        selectedOptions[`option${i}`] = activeBtn.dataset.value;
      }
    }
    
    // Busca variante que corresponde
    const matchingVariant = currentProduct.variants.find(variant => {
      return Object.keys(selectedOptions).every(key => 
        variant[key] === selectedOptions[key]
      );
    });
    
    if (matchingVariant) {
      // Atualiza botão
      addBtn.dataset.variantId = matchingVariant.id;
      addBtn.disabled = !matchingVariant.available;
      addBtn.textContent = matchingVariant.available ? 'Comprar' : 'Indisponível';
      
      // Atualiza imagem
      if (matchingVariant.featured_image) {
        const img = modal.querySelector('.quick-add-modal__image img');
        img.src = matchingVariant.featured_image.src;
      }
      
      // Atualiza disponibilidade de outras opções
      updateOptionAvailability(selectedOptions);
    }
  }

  /**
   * Atualiza disponibilidade das opções baseado na seleção atual
   */
  function updateOptionAvailability(selectedOptions) {
    const modal = document.querySelector('.quick-add-modal');
    
    // Para cada opção, verifica quais valores ainda têm variantes disponíveis
    for (let i = 1; i <= 3; i++) {
      const optionButtons = modal.querySelectorAll(`.quick-add-modal__value[data-option-index="${i}"]`);
      
      optionButtons.forEach(btn => {
        const testOptions = {...selectedOptions, [`option${i}`]: btn.dataset.value};
        
        // Verifica se existe variante disponível com essa combinação
        const hasAvailableVariant = currentProduct.variants.some(variant => {
          return Object.keys(testOptions).every(key => 
            variant[key] === testOptions[key]
          ) && variant.available;
        });
        
        if (hasAvailableVariant) {
          btn.classList.remove('unavailable');
          btn.disabled = false;
        } else {
          btn.classList.add('unavailable');
          btn.disabled = true;
        }
      });
    }
  }

  /**
   * Adiciona ao carrinho
   */
  function addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      // Toast de sucesso
      if (window.theme && window.theme.showToast) {
        window.theme.showToast('✓ Produto adicionado ao carrinho!', 'success', 2000);
      }
      
      // Abre mini cart
      if (window.theme && window.theme.openMiniCart) {
        window.theme.openMiniCart();
      }
    })
    .catch(error => {
      console.error('Erro ao adicionar ao carrinho:', error);
      if (window.theme && window.theme.showToast) {
        window.theme.showToast('Erro ao adicionar produto', 'error', 3000);
      }
    });
  }

  /**
   * Troca variante no product card
   */
  window.changeProductCardVariant = function(button, productHandle) {
    const card = button.closest('.product-card');
    const variantId = button.dataset.variantId;
    const variantImage = button.dataset.variantImage;
    const variantImageSrcset = button.dataset.variantImageSrcset;
    
    // Atualiza imagem se existir
    if (variantImage) {
      const primaryImage = card.querySelector('.product-card__image--primary');
      if (primaryImage) {
        primaryImage.src = variantImage;
        if (variantImageSrcset) {
          primaryImage.srcset = variantImageSrcset;
        }
      }
    }
    
    // Atualiza todas as bolinhas de cor (remove active)
    const allSwatches = card.querySelectorAll('.product-card__color-swatch');
    allSwatches.forEach(swatch => swatch.classList.remove('active'));
    
    // Adiciona active na bolinha clicada
    button.classList.add('active');
    
    // Atualiza variant-id nos botões de quick add
    const quickBuyButtons = card.querySelectorAll('.product-card__quick-buy');
    quickBuyButtons.forEach(btn => {
      btn.dataset.variantId = variantId;
      // Atualiza onclick
      btn.setAttribute('onclick', `event.preventDefault(); window.quickAddProduct('${productHandle}', ${variantId});`);
    });
  };

})();
